(() => {
  'use strict';
  if (window.hfAccountMenuReady) return;
  window.hfAccountMenuReady = true;
  const selector = '[data-hf-account-menu]';
  let syncingNavigation = false;
  const reflect = menu => menu.querySelector('summary')?.setAttribute('aria-expanded', String(menu.open));
  const close = (menu, restoreFocus = false) => {
    menu.open = false;
    reflect(menu);
    if (restoreFocus) menu.querySelector('summary')?.focus({ preventScroll: true });
  };
  const openMenus = () => Array.from(document.querySelectorAll(`${selector}[open]`));
  document.querySelectorAll(selector).forEach(reflect);
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement)) return;
    if (menu.matches(selector)) {
      reflect(menu);
      if (!menu.open) return;
      openMenus().forEach(other => { if (other !== menu) close(other); });
      const header = menu.closest('.site-header');
      header?.querySelectorAll('.nav-item[open]').forEach(item => { item.open = false; });
      const navigationToggle = header?.querySelector('.menu-toggle[aria-expanded="true"]');
      if (navigationToggle) {
        syncingNavigation = true;
        navigationToggle.click();
        syncingNavigation = false;
      }
    } else if (menu.matches('.nav-item') && menu.open) {
      openMenus().forEach(item => close(item));
    }
  }, true);
  document.addEventListener('pointerdown', event => {
    openMenus().forEach(menu => { if (!menu.contains(event.target)) close(menu); });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = openMenus()[0];
    if (!menu) return;
    event.preventDefault();
    event.stopPropagation();
    close(menu, true);
  }, true);
  document.addEventListener('focusin', event => {
    openMenus().forEach(menu => { if (!menu.contains(event.target)) close(menu); });
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (syncingNavigation) return;
    // Click also covers assistive-technology activation without pointerdown.
    if (!target?.closest(selector) || target?.closest('.menu-toggle')) openMenus().forEach(menu => close(menu));
  });
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll(selector).forEach(reflect);
  });
})();
